export default "__VITE_ASSET__426ab0f7__"